import api from "../lib/axios";

const BASE_URL = "/TeamMember";

export const teamService = {
  getPublishedAsync: async () => {
    const response = await api.get(`${BASE_URL}/get-published`);
    return response.data;
  }
};
